<template>
  <el-dialog
    title="ユーザー追加"
    :visible.sync="isOpenCreateModal"
    width="30%"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="onCloseModal"
  >
    <el-form
      ref="creationForm"
      :model="user"
      label-width="30%"
      :rules="rules"
      label-position="top"
      @submit.prevent.native="onSubmit"
    >
      <div>
        <ErrorMessage :messages="errorMessages" @close="errorMessages = null" />
      </div>
      <el-form-item label="ユーザー名 " prop="full_name">
        <el-input name="full_name" v-model="user.full_name" />
      </el-form-item>
      <el-form-item label="ユーザーのメールアドレス" prop="email">
        <el-input name="email" v-model="user.email" />
      </el-form-item>
      <el-form-item label="利用できる機能" prop="menu_ids" class="menu-list">
        <div v-for="(item, index) in user.menu_ids" :key="index" class="item-data">
          <el-checkbox v-model="user.menu_ids[index].checked" :label="true" @change="handleChange(index)">
            {{ item.title }}
          </el-checkbox>
          <el-radio-group v-if="user.menu_ids[index].checked" v-model="user.menu_ids[index].action" class="ml-4">
            <el-radio :label="READ" size="large">一般ユーザー </el-radio>
            <el-radio :label="ALL" size="large">アドミン</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="パスワード" prop="password">
        <el-input type="password" name="password" v-model="user.password" />
      </el-form-item>
      <div class="text-right">
        <el-button @click="onCloseModal">キャンセル</el-button>
        <el-button native-type="submit" type="primary" :disabled="isLoading">
          <i v-if="isLoading" class="el-icon-loading"></i>
          追加
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import { validEmail } from "@/utils/validate";
import { mapActions, mapState } from "vuex";
import ErrorMessage from "@/components/ErrorMessage";
import EngineApi from "@/api/engine.api";
import {READ, ALL} from "@/const/batch";

export default {
  name: "CreateUser",
  components: { ErrorMessage },

  data() {
    return {
      user: {
        user_name: null,
        email: null,
        password: null,
        menu_ids: [],
        org_id: null,
      },
      dataMenu: [],
      rules: {
        full_name: [
          {
            required: true,
            trigger: "blur",
            message: 'ユーザー名を入力してください。'
          },
          { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
        ],
        menu_ids: [
          {
            type: 'array',
            required: true,
            trigger: "change",
            message: '利用できる機能を選んでください。'
          },
          {
            validator: (rule, value, callback) => {
              if (value.length < 1) {
                callback(new Error("利用できる機能を選んでください。"));
              } else {
                let index = 0;
                value.forEach((item) => {
                  if (item.checked) {
                    index += 1;
                  }
                })
                if (!index) {
                  callback(new Error("利用できる機能を選んでください。"));
                }
                callback();
              }
            },
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: 'パスワードを入力してください。'
          },
        ],
        email: [
          {
            required: true,
            trigger: "blur",
            message: 'ユーザーのメールアドレスを入力してください。'
          },
          {
            validator: (rule, value, callback) => {
              if (!validEmail(value)) {
                callback(new Error("有効なメールアドレスを入力してください。"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
        ],
      },
      isLoading: false,
      errorMessages: null,
      READ,
      ALL
    };
  },

  props: {
    isOpenCreateModal: {
      default: false,
    },
    orgId: {
      required: true,
    }
  },

  computed: {
    ...mapState({
      organizations: (state) => state.admin_organizations.organizations,
    }),
  },
  methods: {
    ...mapActions("admin_user", ["create"]),
    onCloseModal() {
      this.user.full_name = null
      this.user.email = null
      this.user.password = null
      this.user.menu_ids = []
      this.user.org_id = null
      this.$refs.creationForm.resetFields();
      this.$refs.creationForm.clearValidate();
      this.$emit("close");
      return true;
    },

    async initData() {
      await this.getListMenu()
      this.errorMessages = null;
    },

    async getListMenu() {
      await EngineApi.getMenu().then((res) => {
        this.dataMenu = res.data
        this.user.menu_ids = this.getEngineIdsInit(res.data)
      })
    },

    async onSubmit() {
      if (this.isLoading) return false;
      this.errorMessages = null;
      this.$refs.creationForm.validate(async (isValid) => {
        if (!isValid) return false;
        let menuList = [];
        this.user.menu_ids.forEach((item) => {
          if (item.checked) {
            menuList.push({id: item.id, action: item.action})
          }
        })
        this.isLoading = true;
        this.user.org_id = this.orgId
        let res = await this.create({...this.user, menu_list: menuList, menu_ids: []});
        this.isLoading = false;
        if (!res.success) {
          if (res.data) this.errorMessages = res.data;
          return false;
        }
        this.$refs.creationForm.resetFields();
        this.$refs.creationForm.clearValidate();
        this.$emit("onUserCreated");
      });
    },
    getEngineIdsInit(data) {
      const arr = []
      for (const item of data) {
        if (item.id) {
          arr.push({
            id: item.id,
            checked: false,
            action: READ,
            title: item.title
          })
        }
      }
      return arr
    },
    handleChange(index) {
      this.user.menu_ids[index].action = READ
    }
  },

  watch: {
    isOpenCreateModal(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.initData();
    },
  },
};
</script>

<style scoped>
/deep/.el-form-item__label {
  line-height: normal;
}

/deep/.menu-list > .el-form-item__content > .item-data > .el-checkbox {
  width: 100%;
}
</style>
